export default class ReportThumbnailsChecklistItem {
  constructor(checklistItemId) {
    this.checklistItemId = checklistItemId;
    this.photo = null; //Defect photo will be stored here
  }
}
